import React from 'react';
import AriesButton from './AriesButton';

/**
 * AriesPrimaryButton — green primary pill. Inherits AriesButton behavior and
 * locks the `primary` variant. Primary-specific overrides can live here.
 */
const AriesPrimaryButton = (props) => (
  <AriesButton {...props} variant="primary" />
);

export default AriesPrimaryButton;
